import React, { useRef } from 'react';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { auth, firestore } from '../../firebase';
import Question from '../Question/Question';

const AskQuestion = () => {
    const questionInputRef = useRef();
    const questionsRef = firestore.collection("questions");
    const [questions] = useCollectionData(questionsRef, {idField: 'id'});

    return (
        <div>
            <h1>Ask your question here...</h1>
            <form onSubmit={handleAskQuestion}>
                <textarea
                    cols="30"
                    rows="10"
                    placeholder="Ask anything you wanna explore"
                    ref={questionInputRef}
                    required
                ></textarea>
                <br/>
                <br/>
                <button className="btn submitBtn">Ask</button>
                <br/>
            </form>
            <div>{
                questions && questions.map(question => {
                    return <Question question={question} />
                })
            }</div>
        </div>
    );
    async function handleAskQuestion(e) {
        e.preventDefault();
        const questionText = questionInputRef.current.value;
        await questionsRef.add({
            text: questionText,
            time: new Date().getTime(),
            user: auth.currentUser.uid

        })
        questionInputRef.current.value = "";
    }
};

export default AskQuestion;